<ng-container>
    <ng-select #ngselect class="ng-option ng-input"
        [items]="items"
        bindLabel="text"
        bindValue="value"
        placeholder=""
        [closeOnSelect]="true"
        notFoundText=""
        [clearable]="false"
        [(ngModel)]="ngModelSelect"
        (ngModelChange)="changeSelect()"
        (open)="focusInputField()"
        (close)="onCloseDropdown()"
        (search)="SearchInputField()"
        (change)="addSelectedItem()"
        [class.has-error]="hasError"
        [class.disabled]="disabled"
    >
</ng-select>
</ng-container>